

const LiveGameScoreboard = (({ scoreData }) => {
    console.log(scoreData)


    return (
        <div className="live-scoreboard">
            <div className="live-scoreboard-category">
                <h3>Score this round</h3>
                <p>{`${scoreData.roundCorrect}/${scoreData.roundNumQuestions}`}</p>
            </div>
            <div className="live-scoreboard-category">
                <h3>High score this round</h3>
                <p>{`${scoreData.roundHighScore}/${scoreData.roundIndividualNumQuestions}`}</p>
                {scoreData.roundHighScorePlayers.map(player => (
                    <p key={`hsr-${player}`}>{player}</p>
                ))}
            </div>
            <div className="live-scoreboard-category">
                <h3>My score this round</h3>
                <p>{`${scoreData.personalNumCorrect}/${scoreData.roundIndividualNumQuestions}`}</p>
            </div>
            <div className="live-scoreboard-category">
                <h3>Total Score</h3>
                <p>{`${scoreData.totalCorrect}/${scoreData.totalNumQuestions} - ${parseFloat((scoreData.totalCorrect / scoreData.totalNumQuestions * 100).toFixed(2))}%`}</p>
            </div>
            <div className="live-scoreboard-category">
                <h3>Game Leader</h3>
                <p>{`${scoreData.totalHighScore}/${scoreData.highScoreNumQuestions} - ${parseFloat((scoreData.totalHighScore / scoreData.highScoreNumQuestions * 100).toFixed(2))}%`}</p>
                {scoreData.totalHighScorePlayers.map(player => (
                    <p key={`hst-${player}`}>{player}</p>
                ))}
            </div>
            <div className="live-scoreboard-category">
                <h3>My total score</h3>
                <p>{`${scoreData.personalTotalCorrect}/${scoreData.highScoreNumQuestions} - ${parseFloat((scoreData.personalTotalCorrect / scoreData.highScoreNumQuestions * 100).toFixed(2))}%`}</p>
            </div>
        </div>
    );
})

export default LiveGameScoreboard